import React, { useState } from "react";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import dropdownarrow from "../assets/kangaroo/dropdown-arrow.png";
import { Col, Container, Row } from "reactstrap";
import img1 from "../assets/kangaroo/Vending.png";
import img2 from "../assets/kangaroo/GraduationCap.png";
import img3 from "../assets/kangaroo/medicalreport.png";
import img4 from "../assets/kangaroo/TaxReport.png";
import Button from "../component/button/Button";
import "../Homepage/Component/Homepage.css";
import Select from "react-select/base";
import Dropdown from "../component/dropdown/Dropdown";
import selectbtn from "../assets/kangaroo/selectbtn.svg";
import { useNavigate } from "react-router-dom";
import Smallbutton from "../component/button/Smallbutton";
import Destinationcountry from "../services/Destinationcountry";
import { useQuery } from "@tanstack/react-query";

const DestinationSelect = ({data}) => {
  console.log("destincationasdas",data)
  const [selectedItem, setSelectedItem] = useState(null);
  const router = useNavigate()

  const fetchCountryData = async () => {
    const response = await Destinationcountry.getList(); 
    return response;
  };

  const { isPending, error, data: countrydata } = useQuery({
    queryKey: ['countryData'],
    queryFn: fetchCountryData,
  });

  const countryOptions =
    countrydata
      ?.filter((item) => item.isActive)
      ?.map((item) => ({
        id: item.id,
        label: item.name,
        slug: item.slug,
      })) || [];

  return (
    <div className="main-container " style={{marginBottom:"clamp(3rem, 6.1vw, 7.5rem)"}}>
      <Container fluid className="h-100 " >
        <Row className="d-flex justify-content-center align-items-center h-100 g-4">
          {/* Left Column - Text Content */}
          <Col xs={12} md={12} lg={5} className="mb-3 mb-lg-0">
            <h1 className="text-start lh-1 mb-3 mb-md-4 font-level-4 fw-normal">
              {data?.[0]?.heading}
            </h1>
            <p className="text-muted font-level-6 mb-0">
              {data?.[0]?.description}
            </p>
          </Col>

          {/* Spacer Column for large screens */}
          <Col lg={1} className="d-none d-lg-block"></Col>
   
          {/* Right Column - Icons, Dropdown & Button */}
          <Col xs={12} md={12} lg={6} className="d-flex justify-content-center justify-content-lg-end">
            <div className="w-100" style={{ maxWidth: "500px" }}>
              {/* Icons Row */}
              <div className="d-flex justify-content-between align-items-center mb-4 mb-md-5 px-2">
                <img 
                  src={img1} 
                  alt="Australia"  
                  className="img-fluid"
                  style={{ width: "clamp(45px, 10vw, 62px)", height: "auto" }} 
                />
                <img 
                  src={img2} 
                  alt="New Zealand" 
                  className="img-fluid"
                  style={{ width: "clamp(45px, 10vw, 58px)", height: "auto" }}
                />
                <img 
                  src={img3} 
                  alt="UK" 
                  className="img-fluid"
                  style={{ width: "clamp(45px, 10vw, 58px)", height: "auto" }}
                />
                <img 
                  src={img4} 
                  alt="USA" 
                  className="img-fluid"
                  style={{ width: "clamp(45px, 10vw, 58px)", height: "auto" }}
                />
              </div>

              {/* Dropdown */}
              <div className="mb-4 mb-md-5 px-2">
                <Dropdown
                  items={countryOptions}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  placeholder="SELECT "
                />
              </div>

              {/* Button */}
              <div className="d-flex justify-content-start justify-content-md-start px-2">
                <div
                  onClick={() => {
                    if (selectedItem?.slug) {
                      router(`/services/${selectedItem.slug}`);
                    }
                  }}
                  style={{ cursor: selectedItem?.slug ? 'pointer' : 'not-allowed' }}
                >
                  <Smallbutton
                    width="clamp(160px, 40vw, 190px)"
                    height="clamp(50px, 12vw, 60px)"
                    text={data?.[0]?.buttonText}
                    textColor={data?.[0]?.buttonColor}
                    fontSize="clamp(20px, 5vw, 24px)"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DestinationSelect;